module.exports = __webpack_public_path__ + "static/media/how_to_dispose_en.9d114496.png";